var map = {
	"./current/back.jpg": 155,
	"./ranchlife/back-colored.jpg": 347,
	"./ranchlife/back.jpg": 348,
	"./ranchlife/missing.jpg": 349,
	"./sienna/back.jpg": 155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;